// extracted by mini-css-extract-plugin
export default {"body":"style_body__fam+M"};